export default "__VITE_ASSET__C$SsxoKe__"